import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Bull from "../bullet/Bull";

export default function ErrorTextCard({ inputMessages, bgColor }: any) {
  const [messages, setMessages] = React.useState<string[]>([]);
  React.useEffect(() => {
    if (inputMessages) setMessages(inputMessages);
  }, [inputMessages]);
  const bull = <Bull scale="scale(2)" color="#e6123d" />;
  //todo change modelError
  return (
    <Card className="marginRight-0 mTop10 mbottom20 iranSansMedium">
      <CardContent
        sx={{
          background: `${bgColor!}`,
          textAlign: "justify",
          borderRadius: "14px",
        }}
      >
        {messages?.map((item: any) => (
          <Typography
            color="text.secondary  textFont14 fontWeight"
            gutterBottom
          >
            {bull}
            {item}
            {/* {item.errorsHeader}
            {item?.errorMessages?.map((msgItem: any) => (
              <Typography
                color="text.secondary"
                style={{ paddingRight: "15px" }}
                gutterBottom
              >
                {msgItem}
              </Typography>
            ))} */}
          </Typography>
        ))}
      </CardContent>
    </Card>
  );
}
